import * as React from "react";

export { Search } from "./Search";
export { Paging } from "./Paging";

export type ChevronItemProps = {
    isDisabled: boolean
}

export const ChevronLeftItem = (props: ChevronItemProps): JSX.Element => (
    <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0.489843 7.20322L6.86484 0.828223C7.30547 0.387598 8.01797 0.387598 8.45391 0.828223L9.51328 1.8876C9.95391 2.32822 9.95391 3.04072 9.51328 3.47666L4.99453 7.99541L9.51328 12.5142C9.95391 12.9548 9.95391 13.6673 9.51328 14.1032L8.45859 15.172C8.01797 15.6126 7.30547 15.6126 6.86953 15.172L0.494531 8.79697C0.0492188 8.35635 0.0492179 7.64385 0.489843 7.20322Z"
            fill={(props.isDisabled) ? "#D6D6D6" : "#eead1f" }
        />
    </svg>
);

export const ChevronRightItem = (props: ChevronItemProps): JSX.Element => (
    <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.51016 8.79678L3.13516 15.1718C2.69453 15.6124 1.98203 15.6124 1.54609 15.1718L0.486718 14.1124C0.0460926 13.6718 0.0460927 12.9593 0.486718 12.5233L5.00547 8.00459L0.486719 3.48584C0.0460935 3.04521 0.0460936 2.33271 0.486719 1.89678L1.54141 0.828027C1.98203 0.387403 2.69453 0.387403 3.13047 0.828028L9.50547 7.20303C9.95078 7.64365 9.95078 8.35615 9.51016 8.79678Z"
            fill={(props.isDisabled) ? "#D6D6D6" : "#eead1f" }
        />
    </svg>
);

export const GlassIcon = (): JSX.Element => (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M18 10C18 14.4183 14.4183 18 10 18C5.58173 18 2 14.4183 2 10C2 5.58172 5.58173 2 10 2C14.4183 2 18 5.58172 18 10ZM16.3286 17.743C14.6048 19.1537 12.4012 20 10 20C4.47714 20 0 15.5228 0 10C0 4.47715 4.47714 0 10 0C15.5229 0 20 4.47715 20 10C20 12.4013 19.1536 14.6049 17.7429 16.3288L24.8993 23.4853C25.2899 23.8758 25.2899 24.509 24.8993 24.8995C24.5088 25.29 23.8756 25.29 23.4851 24.8995L16.3286 17.743Z" fill="white"/>
    </svg>
)
